export const slugPath = (
  slug: string | null | undefined,
  id: number | string | null | undefined
): string => `${slug || id}/${id}`;
